import React from "react";
import { Box, Typography } from "@mui/material";
import backChevronIcon from "@assets/facilityNetwork/ac-back-left.svg";
import { FacilityNetworkReturnIcon } from "./facilityNetworkAddChildIcons";
import FacilityNetworkFigmaIcon from "./FacilityNetworkFigmaIcon";
import { FN } from "./facilityNetworkTheme";

type Props = {
  label?: string;
  onClick: () => void;
  variant?: "button" | "link";
};

export default function FacilityNetworkBackButton({
  label = "Back to facility network",
  onClick,
  variant = "button",
}: Props) {
  const isLink = variant === "link";

  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={
        isLink
          ? {
              alignSelf: "flex-start",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              border: "none",
              bgcolor: "transparent",
              pr: 1.5,
              py: 0.75,
              cursor: "pointer",
              fontFamily: FN.fontFamily,
              "&:hover": { bgcolor: "transparent" },
            }
          : {
              alignSelf: "flex-start",
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              border: "1px solid #b3b3b3",
              borderRadius: "8px",
              bgcolor: "#fff",
              px: 3,
              py: 1.5,
              cursor: "pointer",
              boxShadow: "0px 4px 2px rgba(194,194,194,0.25)",
              fontFamily: FN.fontFamily,
              "&:hover": { bgcolor: "#fafafa" },
            }
      }
    >
      {isLink ? (
        <FacilityNetworkFigmaIcon src={backChevronIcon} size={20} />
      ) : (
        <FacilityNetworkReturnIcon size={15} color={FN.text} />
      )}
      <Typography
        component="span"
        sx={{
          fontFamily: FN.fontFamily,
          fontSize: 14,
          fontWeight: 600,
          color: isLink ? FN.primary : FN.text,
          lineHeight: isLink ? "20px" : 1,
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
